<main id="not-found">
	<section id="not-found-content">
		<header id="not-found-header">
			<h1>404 - Página Não Encontrada</h1>
		</header>
		<p id="not-found-message">
			Desculpe, a página que você está procurando não existe.
		</p>
		<nav>
			<a routerLink="/" class="button">Voltar para a Página Inicial</a>
		</nav>
	</section>
</main>
